// src/config/packages.js

export const PACKAGE_LABEL = {
  // 🔹 ใช้กับฟอร์มสัญญา (ContractForm.jsx)
  pipe3993:
    "แพ็กเกจกำจัดปลวก 3,993 บาท (อัดน้ำยาลงท่อ + ฉีดพ่นเสริมทุกจุดภายในบ้าน)",
  bait5500_in:
    "แพ็กเกจกำจัดปลวก 5,500 บาท (ระบบเหยื่อภายใน + ฉีดพ่นเสริมทุกจุดภายในบ้าน)",
  bait5500_out:
    "แพ็กเกจกำจัดปลวก 5,500 บาท (ระบบเหยื่อภายนอก + ฉีดพ่นเสริมทุกจุดภายในบ้าน)",
  bait5500_both:
    "แพ็กเกจกำจัดปลวก 5,500 บาท (ระบบเหยื่อทั้ง 2 แบบ + ฉีดพ่นเสริมทุกจุดภายในบ้าน)",
  combo8500:
    "แพ็กเกจกำจัดปลวก 8,500 บาท (ระบบเหยื่อ + อัดน้ำยาลงท่อ + ฉีดพ่นเสริมทุกจุดภายในบ้าน)",

  // 🔹 key เดิม (ถ้ายังมีที่อื่นใช้)
  spray: "[ระบบอัดน้ำยาลงท่อ + ฉีดพ่นเสริมทุกจุดภายในบ้าน]",
  bait:  "[ระบบเหยื่อ + ฉีดพ่นเสริมทุกจุดภายในบ้าน]",
  mix:   "[ระบบเหยื่อ + อัดน้ำยาลงท่อ + ฉีดพ่นเสริมทุกจุดภายในบ้าน]",
};

export const PACKAGE_PRICE = {
  pipe3993: 3993,
  bait5500_in: 5500,
  bait5500_out: 5500,
  bait5500_both: 5500,
  combo8500: 8500,
};

export const getPackageLabel = (k) => PACKAGE_LABEL[k] || String(k || "");
export const getPackagePrice = (k) => PACKAGE_PRICE[k] ?? 0;
